import 'css-chunksrc/client/scenes/eventCreation/form/participantsList/styles.scss';export default {
  "participantsList": "_participantsList_1ihi1_1",
  "root": "_root_1ihi1_8",
  "list": "_list_1ihi1_12",
  "main": "_main_1ihi1_20",
  "summary": "_summary_1ihi1_27",
  "menu": "_menu_1ihi1_36",
  "addParticipantIcon": "_addParticipantIcon_1ihi1_40",
  "resourcesList": "_resourcesList_1ihi1_46",
  "quickParticipantMenu": "_quickParticipantMenu_1ihi1_53",
  "overlay": "_overlay_1ihi1_61",
  "participants": "_participants_1ihi1_1",
  "participant": "_participant_1ihi1_1"
};